import mapDefaultValue from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/DeployModal/mapDefaultValue';
import getSdkConnection from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/DeployModal/getSdkConnection';

export default function buildIntegrationConnection({
  connectionJson,
  vars,
  pipelineVars,
  pipelineVariables,
  starterkitId,
}) {
  const { endpointSchema, connectionTemplate } = connectionJson;
  const connectionType = Object.keys(connectionJson)[0] === 'endpointSchema' ? 'endpointSchema' : 'connection';

  const connection = endpointSchema
    ? mapDefaultValue(endpointSchema, vars, pipelineVars, pipelineVariables)
    : getSdkConnection({
        integrationName: starterkitId,
        connection: connectionTemplate,
        vars,
        pipelineVars,
        pipeline_variables: pipelineVariables,
      });

  return { connectionType, connection };
}
